import { render, staticRenderFns } from "./nimp_logo_image.vue?vue&type=template&id=0cb10a65&scoped=true&"
import script from "./nimp_logo_image.vue?vue&type=script&lang=js&"
export * from "./nimp_logo_image.vue?vue&type=script&lang=js&"
import style0 from "./nimp_logo_image.vue?vue&type=style&index=0&id=0cb10a65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb10a65",
  null
  
)

export default component.exports